export const EditStepButton = angular
    .module('checkout.components.editStepButton', [])
    .component('editStepButton', {
        template: `
            <button
                class="checkout-button checkout-button--border"
                type="button"
                ng-click="$ctrl.onClick({ event: $event })">
                Edit
            </button>
        `,
        bindings: {
            onClick: '&'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editStepButton/editStepButton.js